import React, { Component } from "react";

// Components:
import Placeholder from "../Placeholder";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return <Placeholder title="Dashboard" />;
  }
}

export default Dashboard;
